import { createReducer } from '@reduxjs/toolkit';

import * as actionTypes from '../../../actionTypes';

/**
 * @typedef {import('modules/works/types').TabChoicesEnum} SelectedState
 */

/** @type {SelectedState} */
const initialState = null;

const set = (_, { payload: tab }) => tab;

export default createReducer(initialState, (builder) => {
  builder.addCase(actionTypes.SELECT_TAB, set);
});
